import React from 'react';

import contents from './contents.json'
import './CircleLan.css'
import Accordion from "../../../components/accordion";
import {SEO} from "../../../components/SEO";

function CircleLan() {
    return (
        <div className="circle_lan">
            <SEO isDefault />
            <ul>
                <li>
                    {
                        contents.map(heading => (
                            <Accordion key={Object.keys(heading)[0]} heading={heading} />
                        ))
                    }
                </li>
            </ul>

        </div>
    );
}

export default CircleLan;